"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileCard = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const download_helper_1 = require("@front/helpers/download.helper");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="file-card-container">
    
    <div class="loading-state" ?hidden="${x => !x.loading}">
        <app-loader></app-loader>
    </div>

    
    <div class="error-state alert alert-danger" ?hidden="${x => !x.error}">
        <i class="simple-icon-exclamation me-2"></i>
        ${x => x.error}
    </div>

    
    <div class="file-content" ?hidden="${x => x.loading || !!x.error}">
        ${(0, fast_element_1.when)(x => x.preview && x.isPreviewableFile, (0, fast_element_1.html) `
            
            <div class="preview-file">
                ${(0, fast_element_1.when)(x => x.isImageFile, (0, fast_element_1.html) `
                    <img 
                        src="${x => x.getFilePath()}" 
                        alt="${x => x.fileName}"
                        class="file-preview-image"
                    />
                `)}
                ${(0, fast_element_1.when)(x => x.isVideoFile, (0, fast_element_1.html) `
                    <video 
                        src="${x => x.getFilePath()}" 
                        class="file-preview-video"
                        controls
                        preload="metadata"
                    >
                        ${'file-card.videoNotSupported'.t()}
                    </video>
                `)}
                <div class="preview-info">
                    <div class="file-name">${x => x.fileName}</div>
                    <div class="file-meta">
                        <span class="file-type">${x => { var _a; return (_a = x.ext) === null || _a === void 0 ? void 0 : _a.toUpperCase(); }}</span>
                        <span class="file-size">${x => x.fileSize}</span>
                    </div>
                </div>
                
                <div class="file-actions" ?hidden="${x => !x.showDownload && !x.showAddToKdb}">
                    ${(0, fast_element_1.when)(x => x.showDownload, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-secondary btn-sm" 
                            @click="${x => x.handleDownload()}"
                            title="${'file-card.download'.t()}"
                        >
                            <i class="simple-icon-cloud-download"></i>
                        </button>
                    `)}
                    ${(0, fast_element_1.when)(x => x.showAddToKdb, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-outline-primary btn-sm" 
                            @click="${x => x.handleAddToKdb()}"
                            title="${'file-card.addToKdb'.t()}"
                        >
                            <i class="simple-icon-book-open"></i>
                        </button>
                    `)}
                </div>
            </div>
        `, (0, fast_element_1.html) `
            
            <div class="non-preview-file">
                <div class="file-item__icon">
                    <i class="simple-icon-paper-clip"></i>
                </div>
                <div class="file-item__info">
                    <div class="file-item__name">${x => x.fileName}</div>
                    <div class="file-item__footer">
                        <div class="file-item__ext">${x => x.ext}</div>
                        <div class="file-item__size">${x => x.fileSize}</div>
                    </div>                    
                </div>
                
                <div class="file-actions" ?hidden="${x => !x.showDownload && !x.showAddToKdb}">
                    ${(0, fast_element_1.when)(x => x.showDownload, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-secondary btn-sm" 
                            @click="${x => x.handleDownload()}"
                            title="${'file-card.download'.t()}"
                        >
                            <i class="simple-icon-cloud-download"></i>
                        </button>
                    `)}
                    ${(0, fast_element_1.when)(x => x.showAddToKdb, (0, fast_element_1.html) `
                        <button 
                            class="btn btn-outline-primary btn-sm" 
                            @click="${x => x.handleAddToKdb()}"
                            title="${'file-card.addToKdb'.t()}"
                        >
                            <i class="simple-icon-book-open"></i>
                        </button>
                    `)}
                </div>
            </div>
        `)}
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.file-card-container {
  display: block;
  width: 100%;
}
.file-card-container .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.file-card-container .loading-state .spinner-border {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
}
.file-card-container .error-state {
  margin: 0;
  padding: 0.75rem;
}
.file-card-container .file-content .preview-file {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  overflow: hidden;
  background-color: #ffffff;
}
.file-card-container .file-content .preview-file .file-preview-image {
  display: block;
  max-width: 100%;
  height: auto;
  width: 100%;
  object-fit: cover;
  max-height: 300px;
}
.file-card-container .file-content .preview-file .file-preview-video {
  display: block;
  width: 100%;
  max-height: 300px;
  background-color: #000000;
}
.file-card-container .file-content .preview-file .preview-info {
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}
.file-card-container .file-content .preview-file .preview-info .file-name {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  word-break: break-word;
}
.file-card-container .file-content .preview-file .preview-info .file-meta {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
}
.file-card-container .file-content .preview-file .preview-info .file-meta .file-type {
  font-size: 0.875rem;
  color: var(--primary-color);
  text-transform: uppercase;
  font-weight: 500;
}
.file-card-container .file-content .preview-file .preview-info .file-meta .file-size {
  font-size: 0.75rem;
  color: #6c757d;
}
.file-card-container .file-content .preview-file .file-actions {
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  display: flex;
  gap: 0.25rem;
  justify-content: flex-end;
}
.file-card-container .file-content .preview-file .file-actions .btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
.file-card-container .file-content .preview-file .file-actions .btn i {
  font-size: 0.75rem;
}
.file-card-container .file-content .non-preview-file {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  background-color: #f8f9fa;
}
.file-card-container .file-content .non-preview-file .file-item__icon {
  margin-right: 0.75rem;
  font-size: 1.5rem;
  color: #6c757d;
  flex-shrink: 0;
}
.file-card-container .file-content .non-preview-file .file-item__info {
  flex: 1;
  min-width: 0;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__name {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  word-break: break-word;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__footer {
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  align-items: baseline;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__footer .file-item__ext {
  font-size: 1rem;
  color: var(--primary-color);
  text-transform: uppercase;
  font-weight: 500;
}
.file-card-container .file-content .non-preview-file .file-item__info .file-item__footer .file-item__size {
  font-size: 0.875rem;
  color: #6c757d;
}
.file-card-container .file-content .non-preview-file .file-actions {
  margin-left: 0.5rem;
  flex-shrink: 0;
  display: flex;
  gap: 0.25rem;
}
.file-card-container .file-content .non-preview-file .file-actions .btn {
  font-size: 0.75rem;
  padding: 0.375rem;
  min-width: 2rem;
}
.file-card-container .file-content .non-preview-file .file-actions .btn i {
  font-size: 0.75rem;
}
.file-card-container .file-content .file-actions {
  margin-top: 0.75rem;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.file-card-container .file-content .file-actions .btn {
  font-size: 0.875rem;
}
.file-card-container .file-content .file-actions .btn i {
  font-size: 0.75rem;
}

@media (max-width: 768px) {
  .file-card-container .file-content .file-actions .btn {
    flex: 1;
    min-width: 0;
  }
}`;
const shadowOptions = { "mode": "open" };
let FileCard = class FileCard extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.error = '';
        this.showDownload = true;
        this.showAddToKdb = false;
        this.preview = true;
    }
    async connectedCallback() {
        super.connectedCallback();
        if (this.fileId) {
            await this.getFile();
        }
    }
    fileIdChanged() {
        if (this.fileId) {
            this.getFile();
        }
    }
    async getFile() {
        try {
            this.loading = true;
            this.error = '';
            const response = await this.apiService.back.get('file.get', {
                routeParams: { id: this.fileId }
            });
            this.file = response.data;
        }
        catch (e) {
            console.error('Error loading file:', e);
            this.error = 'file-card.errorLoading'.t();
        }
        finally {
            this.loading = false;
        }
    }
    handleDownload() {
        if (!this.file)
            return;
        try {
            const link = document.createElement('a');
            link.href = download_helper_1.DownloadHelper.getFilePath(this.file);
            link.download = this.file.originalName || this.file.filename || `file-${this.file.id}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (e) {
            console.error('Error downloading file:', e);
        }
    }
    handleAddToKdb() {
        if (!this.file)
            return;
        // Emit event for parent component to handle
        this.$emit('add-to-kdb', { file: this.file });
    }
    get isImageFile() {
        var _a;
        if (!this.file)
            return false;
        return ((_a = this.file.mimeType) === null || _a === void 0 ? void 0 : _a.startsWith('image/')) || false;
    }
    get isVideoFile() {
        var _a;
        if (!this.file)
            return false;
        return ((_a = this.file.mimeType) === null || _a === void 0 ? void 0 : _a.startsWith('video/')) || false;
    }
    get isPreviewableFile() {
        return this.isImageFile || this.isVideoFile;
    }
    get ext() {
        var _a;
        if (!this.file)
            return null;
        return ((_a = this.file.mimeType) === null || _a === void 0 ? void 0 : _a.split('/')[1]) || null;
    }
    get fileName() {
        if (!this.file)
            return 'file-card.unknownFile'.t();
        return this.file.originalName || this.file.filename || 'file-card.unknownFile'.t();
    }
    get fileSize() {
        var _a;
        if (!((_a = this.file) === null || _a === void 0 ? void 0 : _a.size))
            return 'file-card.unknownSize'.t();
        const mbVal = (this.file.size / (1024 * 1024)).toFixed(2);
        return mbVal !== '0.00' ? `${mbVal} MB` : `${(this.file.size / 1024).toFixed(2)} KB`;
    }
    getFilePath() {
        if (!this.file)
            return '';
        return download_helper_1.DownloadHelper.getFilePath(this.file);
    }
};
exports.FileCard = FileCard;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileCard.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], FileCard.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _a : Object)
], FileCard.prototype, "file", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileCard.prototype, "fileId", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FileCard.prototype, "showDownload", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FileCard.prototype, "showAddToKdb", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FileCard.prototype, "preview", void 0);
exports.FileCard = FileCard = __decorate([
    (0, client_1.RWSView)('file-card', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], FileCard);
FileCard.defineComponent();
